module.exports = __webpack_public_path__ + "static/media/afreebird.f6dae0cc.png";